// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-item[data-v-780cecc8]{width:100%;margin-bottom:20px}.image[data-v-780cecc8]{padding:10px}.image[data-v-780cecc8]:hover{cursor:pointer}p[data-v-780cecc8]{word-break:break-all;word-wrap:break-word;white-space:pre-wrap}.tip[data-v-780cecc8]{display:block;width:100%;font-size:10px;color:#999;text-align:center}a[data-v-780cecc8]{color:#000;text-decoration:none}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
